/* Single colour heading — replaces per-letter multicolour */
document.addEventListener('DOMContentLoaded', function () {
  var headings = document.querySelectorAll('.banner__heading');
  headings.forEach(function (heading) {
    /* Remove any existing span wrapping from previous script */
    heading.innerHTML = heading.innerText || heading.textContent;
  });
});
